module.exports = __webpack_public_path__ + "static/img/about1.bcc3956.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/about1.png
// module id = s08Y
// module chunks = 5